export const GOOGLE_MAPS_API_KEY = "AIzaSyAWiMS2z_j0cDc1JsKhHnMjIdlfyOUWtYw";
